﻿import React, { useContext, useCallback, useState } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { Featured_Project, Featured_Projects_List_Item_Props, Featured_Projects_List_Props } from '@Util/Types';
import { write_console_error } from '@Util/Utils';
import { P } from '@Elements/Fonts';
import {
    Icon_Spin
} from '@Elements/ImageElements/Icons';

const Featured_Projects_List: React.FC<Featured_Projects_List_Props> = React.memo((props) => {
    const { featured_projects }: context_type = useContext(Context);

    return (
        <ul className="Dynamic_Island_Featured_Projects_List">
            {featured_projects?.map((project: Featured_Project, index: number): JSX.Element => (
                <Featured_Projects_List_Item
                    key={project.projectId}  // Use project ID as a unique key
                    project={project}
                    index={index}
                    set_menu_is_active={props.set_menu_is_active}
                />
            ))}
        </ul>
    );
});

const Featured_Projects_List_Item: React.FC<Featured_Projects_List_Item_Props> = React.memo((props) => {
    const [t] = useTranslation();
    const { start_time }: context_type = useContext(Context);
    const [is_processing, set_is_processing] = useState<boolean>(false);

    /*const handle_start_project_on_click = useCallback((project_id: number) => {
        try {
            if (!project_id) {
                throw new Error("Start project: Project ID is empty");
            }

            if (!start_time) {
                throw new Error("Start project: Function start_time does not exist");
            }

            start_time(project_id);
            props.set_menu_is_active(false);
        } catch (err) {
            write_console_error(err, err.message);
        }
    }, [start_time, props.set_menu_is_active]);*/

    const handle_start_project_on_click = useCallback(async (project_id: number) => {
        if (!project_id) {
            console.error("Start project: Project ID is empty");
            return;
        }

        if (!start_time) {
            console.error("Start project: Function start_time does not exist");
            return;
        }

        let spinnerTimeout: NodeJS.Timeout | null = null;

        spinnerTimeout = setTimeout(() => {
            set_is_processing(true);
        }, 300);

        try {
            await start_time(project_id);
            props.set_menu_is_active(false);
        } catch (err: any) {
            write_console_error(err, err.message);
        } finally {
            if (spinnerTimeout) clearTimeout(spinnerTimeout);
            set_is_processing(false);
        }
    }, [start_time, props.set_menu_is_active]);

    return (
        <li className="Dynamic_Island_Featured_Projects_List_Item">
            <button
                type="button"
                className="Dynamic_Island_Featured_Projects_List_Item_Button"
                onClick={() => handle_start_project_on_click(props.project.projectId)}
                title={`${t('Hover.StartTrackingOn')} ${props.project.customerName} - ${props.project.projectName}`}
                disabled={is_processing}
            >
                <div className="Dynamic_Island_Featured_Projects_List_Item_Button_Color">
                    {
                        is_processing ?
                            <Icon_Spin /> :
                            <span
                                style={{ backgroundColor: `rgb(${props.project.customerColor})` }}
                                aria-label="hidden"
                            ></span>
                    }
                </div>
                <div className="Dynamic_Island_Featured_Projects_List_Item_Button_Details">
                    <P bold={true}>{`${props.project.customerName}`}</P>
                    <P>-</P>
                    <P>{`${props.project.projectName}`}</P>
                </div>
            </button>
        </li>
    );
});

export default Featured_Projects_List;